import React from 'react';
import { Button, Div, Text } from '@vkontakte/vkui';
import { useOffline } from '../contexts/OfflineContext';

const OfflineToggle = () => {
  const { isOffline, toggleOfflineState } = useOffline();

  return (
    <Div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      padding: '8px 16px',
      background: isOffline ? '#ff6b6b' : '#51cf66',
      borderRadius: '8px',
      marginBottom: '16px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div 
          style={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: isOffline ? '#fff' : '#2d5a27'
          }}
        />
        <Text style={{ color: '#fff', fontWeight: 'bold' }}>
          {isOffline ? 'OFFLINE' : 'ONLINE'}
        </Text>
      </div>
      
      <Button 
        size="s" 
        mode="secondary"
        onClick={toggleOfflineState}
        style={{ 
          backgroundColor: 'rgba(255,255,255,0.2)', 
          border: '1px solid rgba(255,255,255,0.3)',
          color: '#fff'
        }}
      >
        {isOffline ? 'Включить Online' : 'Включить Offline'}
      </Button>
    </Div>
  );
};

export default OfflineToggle; 